import { SET_LANGUAGE } from './action';
import { CHANGE_LANGUAGE } from './../ApplicationLanguage/action';
const initiaState = 'en_GB'

export function languageReducer(state=initiaState, action){
    switch (action.type) {

        case SET_LANGUAGE:
          return action.payload;

        case CHANGE_LANGUAGE:
          return action.payload.code

        default:
          return state;
    };
   }
   
   export default languageReducer;
